import React, {useContext, useEffect, useState, useMemo} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PersonIcon from '@mui/icons-material/Person';
import {Collapse, initTE} from 'tw-elements';

import {getProspects, getPaises, getPaisAtual} from '../../../pages/requests';
import axios from 'axios';

import Spinner from '../../Spinner';

import TablePagination from '../../TablePagination';
import InputFilter from '../../Filters/InputFilter';

import SelectComponent from '../../Selects/SelectComponentFilt';
import {toast} from 'react-toastify';
import * as XLSX from 'xlsx';

function Table({
    onRowClick,
    setEditarProspect,
    filtroNome,
    setFiltroNome,
    filtroNif,
    setFiltroNif,
    filtroCidade,
    setFiltroCidade,
    filtroPais,
    setFiltroPais,
    filtroRepresentante,
    setFiltroRepresentante,
    download,
    setDownload,
    paises,
    representantes,
}) {
    const {t} = useTranslation();

    initTE({Collapse});

    const {isCard, openCards} = useContext(Context);
    const [isMobile, setIsMobile] = useState(false);

    const [prospects, setProspects] = useState([]);
    const [totalRegistos, setTotalRegistos] = useState(0);

    const [currentPage, setCurrentPage] = useState(1);

    // const [paises, setPaises] = useState([]);
    // const [representantes, setRepresentantes] = useState([]);

    const [loading, setLoading] = useState(true);

    const [openAccordion, setOpenAccordion] = useState(null);
    // const handleRowClickAccordion = index => {
    //     setOpenAccordion(openAccordion === index ? null : index);
    // };

    const ITEMS_PER_PAGE = 15;

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    } else if (idiomaAtual == 'es') {
        lang = 'ES';
    }

    const handleRowClick = dados => {
        setEditarProspect(true);
        onRowClick(dados);
    };

    function HandleSpinner() {
        {
            <Spinner />;
        }
    }

    const exportToExcel = data => {
        debugger;
        const hoje = new Date().toLocaleDateString('pt-BR').split('/').join('-');
        const filename = `Contas_${hoje}.xlsx`;

        const worksheet = XLSX.utils.json_to_sheet(data, {
            header: ['Nome', 'NIF', 'Cidade', 'Gestor de Cliente', 'País'],
        });

        // worksheet['!autofilter'] = XLSX.utils.decode_range(worksheet['!ref']);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, `${filename}.xlsx`);
        setDownload(false);
    };

    useEffect(() => {
        debugger;
        if (download) {
            const controller = new AbortController();
            const signal = controller.signal;
            setLoading(true);
            getProspects(
                1,
                9999,
                lang,

                filtroNome.toUpperCase(),
                filtroNif.toUpperCase(),
                filtroCidade.toUpperCase(),
                filtroPais?.value ?? '',
                filtroRepresentante?.value ?? '',
                signal,
            )
                .then(res => {
                    if (res.data.success) {
                        exportToExcel(
                            res.data.clientes?.map(dados => ({
                                Nome: `${dados.codigoCliente} - ${dados.nomeCliente}`,
                                NIF: dados.contribuinte,
                                Cidade: dados.enderecos[0]?.cidade,
                                'Gestor de Cliente': dados.responsavel.label,
                                País: dados.pais.label,
                            })),
                        );
                    } else {
                        res.data.errorMessages.map(m =>
                            toast.error(m, {
                                position: 'top-right',
                                autoClose: 5000,
                            }),
                        );
                    }
                })
                .catch(error => {
                    if (!axios.isCancel(error)) {
                        console.log(error);
                    }
                })
                .finally(() => {
                    setLoading(false);
                });

            return () => {
                controller.abort();
            };
        }
    }, [download]);
 

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        // getPaises(lang).then(res => {
        //     setPaises(res.data.paises);
        // });
        // getRepresentantes(lang).then(res => {
        //     setRepresentantes(res.data.representantes);
        // });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);

        const controller = new AbortController();
        const signal = controller.signal;

        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        setProspects([]);

        setLoading(true);
        getProspects(
            indexOfFirstItem,
            indexOfLastItem - 1,
            lang,

            filtroNome.toUpperCase(),
            filtroNif.toUpperCase(),
            filtroCidade.toUpperCase(),
            filtroPais?.value ?? '',
            filtroRepresentante?.value ?? '',
            signal,
        )
            .then(res => {
                if (res.data.success) {
                    setProspects(res.data.clientes);
                    setTotalRegistos(res.data.totalprodutos);
                    setLoading(false);
                } else {
                    res.data.errorMessages.map(m =>
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 5000,
                        }),
                    );
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            });
        // .finally(() => {
        //     setLoading(false);
        // });

        return () => {
            controller.abort();
        };
    }, [currentPage, filtroNome, filtroNif, filtroCidade, filtroRepresentante, filtroPais]);

    function handleChangeFiltro() {
        return !!filtroNome || !!filtroNif || !!filtroCidade || !!filtroRepresentante || !!filtroPais;
    }

    function limparFiltros() {
        setFiltroNome('');
        setFiltroNif('');
        setFiltroCidade('');
        setFiltroRepresentante(null);
        setFiltroPais(null);
        setCurrentPage(1);
    }

    return (
        <>
            <div>
                {isMobile || isCard ? (
                    <div>
                        {prospects?.map((dados, index) => (
                            <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                <h2 className="mb-0" id="headingOne">
                                    <button
                                        className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                        type="button"
                                        data-te-collapse-init
                                        data-te-collapse-collapsed
                                        data-te-target={'#flush-collapseThree' + index}
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThree">
                                        <div className="flex flex-row" onClick={() => handleRowClick(dados)}>
                                            {dados.tipoCliente == 4 ? (
                                                <div className="text-blue-600 mr-2">
                                                    <PersonSearchIcon />
                                                </div>
                                            ) : (
                                                <div className="text-blue-600 mr-2">
                                                    <PersonIcon />
                                                </div>
                                            )}
                                            {dados.codigoCliente} - {dados.nomeCliente}
                                        </div>
                                        <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    id={'flush-collapseThree' + index}
                                    className={openCards ? 'visible' : '!visible hidden'}
                                    data-te-collapse-item
                                    aria-labelledby="flush-headingThree"
                                    data-te-parent="#accordionFlushExample">
                                    <div className="px-5 py-4">
                                        <div className="dark:text-white flex flex-row">
                                            <div className="font-bold text-gray-400 mr-2">{t('nif')}:</div> {dados.contribuinte}
                                        </div>
                                        <div className="dark:text-white flex flex-row">
                                            <div className="font-bold text-gray-400 mr-2">{t('cidade')}: </div> {dados.enderecos[0]?.cidade}
                                        </div>
                                        <div className="dark:text-white flex flex-row">
                                            <div className="font-bold text-gray-400 mr-2">{t('representante')}: </div> {dados.responsavel?.label}
                                        </div>
                                        <div className="dark:text-white flex flex-row">
                                            <div className="font-bold text-gray-400 mr-2">{t('pais')}: </div> {dados.pais.label}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}

                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            {totalRegistos.lenght != 0 && <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />}
                        </nav>
                    </div>
                ) : (
                    <div className="relative  overflow-x-auto shadow-md sm:rounded-[8px]">
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                <tr>
                                    <th scope="col" className="px-6 py-3">
                                        {t('nome')}
                                        <InputFilter
                                            value={filtroNome}
                                            onSearch={value => {
                                                setFiltroNome(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className="px-6 py-3">
                                        {t('nif')}
                                        <InputFilter
                                            value={filtroNif}
                                            onSearch={value => {
                                                setFiltroNif(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3">
                                        {t('cidade')}
                                        <InputFilter
                                            value={filtroCidade}
                                            onSearch={value => {
                                                setFiltroCidade(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>
                                    <th scope="col" className="px-6 py-3 w-80">
                                        {t('representante')}
                                        <div className="flex flex-row">
                                            <SelectComponent
                                                options={representantes}
                                                value={filtroRepresentante}
                                                onChange={e => {
                                                    setFiltroRepresentante(e);
                                                    setCurrentPage(1);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('filtro')}
                                            />
                                        </div>
                                    </th>
                                    <th scope="col" className="px-6 py-3 w-80">
                                        {t('pais')}
                                        <div className="flex flex-row w-80">
                                            <SelectComponent
                                                options={paises}
                                                value={filtroPais}
                                                onChange={e => {
                                                    setFiltroPais(e);
                                                    setCurrentPage(1);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('filtro')}
                                            />
                                            {handleChangeFiltro() ? (
                                                <button
                                                    onClick={limparFiltros}
                                                    type="button"
                                                    className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                    <FilterAltOffIcon />
                                                </button>
                                            ) : null}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {prospects?.map(dados => (
                                    <tr
                                        className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                        onClick={() => handleRowClick(dados)}>
                                        <th scope="row" className="flex flex-row items-center px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            {dados.tipoCliente == 4 && (
                                                <div className="text-blue-600 mr-2">
                                                    <PersonSearchIcon />
                                                </div>
                                            )}
                                            {dados.tipoCliente != 4 && (
                                                <div className="text-blue-600 mr-2">
                                                    <PersonIcon />
                                                </div>
                                            )}
                                            {dados.codigoCliente} - {dados.nomeCliente}
                                        </th>
                                        <td className="px-6 py-1">{dados.contribuinte}</td>
                                        <td className="px-6 py-1">{dados.enderecos[0]?.cidade}</td>
                                        <td className="px-6 py-1">{dados.responsavel?.label}</td>
                                        <td className="px-6 py-1">{dados.pais.label}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}

                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            {totalRegistos != 0 && <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />}
                        </nav>
                    </div>
                )}
            </div>
        </>
    );
}

export default Table;
